/**
 * Edit close time handler.
 */
import { openCloseTimeModal } from '../../modules/ui';
import type { TableHandlerDeps } from './types';

export function handleEditCloseTime(id: string, e: Event, deps: TableHandlerDeps): void {
  const { state } = deps;

  const lot = state.lots.find((x: unknown) => (x as { id: string }).id === id);
  if (!lot) return;

  e.preventDefault();
  openCloseTimeModal(lot);
}
